import { Button, Modal, Slide } from '@mui/material'
import { useContext } from 'react'
import { ToolContext } from '../../context/ToolContext'
import { Box } from '@mui/system'
import { domain } from '../../Env'
import { DirectTabLoader } from '../../loader/DirectTabLoader'
// import { Close } from '@mui/icons-material'

export const ValidateCompanyMsg = () => {
    const { tool_state } = useContext(ToolContext)
    const { validateCompany, __SESSION } = tool_state



    const handlerRedirectPB = async() => {
        let ssoUrls = `${domain('biz').url}/sso/account/auth?ainfo=${encodeURI(JSON.stringify(__SESSION.data.ainfo))}&ref=callback&st_url=${window.location.href}`
        await DirectTabLoader('BizWN', ssoUrls)
    }

    return (
        <Modal open={validateCompany.data}>
            <Slide in={validateCompany.data} direction='up'>
                <Box height="100%" width="100%" display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                    <Box position="relative" bgcolor="#fff" width="300px" p={4} borderRadius={2} display="flex" flexDirection="column" justifyContent="center">
                        {/* <Box position="absolute" top={3} right={3}><Close sx={{cursor:"pointer"}} onClick={()=> CloseIcon()} fontSize='small'/></Box> */}
                        <Box mb={3} fontSize={16} fontWeight={600} textAlign="center">To access this feature, set up your company details in POFBusiness.</Box>
                        <Button variant="contained" onClick={() => handlerRedirectPB()}>Set up Company</Button>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    )
}
